





































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import MemberBody from '@/components/Table/MemberBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import WinLoseData from '@/data/WinLoseData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';
import NewMemberBody from '@/components/Table/NewMemberBody.vue';
import { saveAs } from 'file-saver';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    MemberBody,
    LogBody,
    NewMemberBody,
    DateRangeLogBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  Criteria = {
    ...this.Period,
    isSearch: false,
    gameName: ['total'],
    products: ['total'],
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    id: this.AuthInstance.user._id,
    sort: 'turnover',
  };

  DefaultGameList = [
    {
      name: 'All',
      value: 'total',
    },
  ];

  sortList = ['turnover', 'agent'];

  companyList = [
    {
      key: 'total',
      name: 'All',
      isActive: true,
    },
    {
      key: 'khm_company_total',
      name: 'Khm Company',
      isActive: false,
    },
    // {
    //   key: 'marketing',
    //   name: 'Marketing',
    //   isActive: false,
    // },
  ]

  GameList: any = [];

  BreadcrumbList: any = [];

  PaginationDetail = {
    amount: 0,
    current: 1,
    size: 100,
  };

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  WinLoseList: any = {};

  resultData: any = {};

  LoginName = '';

  roundId = '';

  TableHeadMember = [...WinLoseData.TableHeadMember];

  TableHeadSubAgent = [...WinLoseData.TableHeadSubAgent];

  FilteredTableHeadMember: Array<object> = [...WinLoseData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  dataKey = 'users';

  isMember = false;

  isSubAgent = false;

  detailFooterCol = 0;

  totalLog = 0;

  summaryLog = 0;

  houseEdge = [];

  totalCurrency: any = [];

  startDate = '';

  endDate = '';

  isToggleAction = false;

  durationTime = '';

  isRangeDate = false;

  currentCurrency = 'All'

  currentAPI = 'v2'

  currencyList: string[] = [];

  ratioCurrency = ['MMK', 'IDR', 'VND', 'KHR', 'KRW', 'LAK', 'COP', 'TZS'];

  gameListForKhm: any = [];

  isRateValid = false;

  rateValue = 0;

  rateCriteria = {};

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  created() {
    this.fetchNewWinlose();
    this.fetchGame();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date)
      .startOf('day')
      .toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      gameName: ['total'],
      products: ['total'],
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      id: this.AuthInstance.user._id,
      sort: 'turnover',
    };
    this.LoginName = '';
    this.isMember = false;
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchNewWinlose();
  }

  filterCurrency(item) {
    this.currentCurrency = item;
    this.currencyList = item === 'All' ? [...this.totalCurrency] : [item];
  }

  filterAPI(item) {
    this.currentAPI = item;
    this.fetchNewWinlose();
  }

  handleBetType({ target: { checked, value } }) {
    if (value === 'total') {
      this.Criteria.gameName = checked
        ? this.GameList.map((item) => item.value)
        : [];
    } else if (value !== 'total') {
      if (checked) {
        this.Criteria.gameName.push(value);
        if (this.Criteria.gameName.length === this.GameList.length - 1) {
          this.Criteria.gameName.push('total');
        }
      } else {
        this.Criteria.gameName = this.Criteria.gameName.filter(
          (item) => item !== value && item !== 'total',
        );
      }
    }
    this.PaginationDetail = {
      current: 1,
      amount: 0,
      size: 100,
    };
    this.fetchNewWinlose();
  }

  selectSort(item) {
    if (this.Criteria.sort === item) return false;
    this.Criteria.sort = item;
    this.fetchNewWinlose();
  }

  selectGame(item) {
    this.Criteria.gameName = [item.prefix.toLowerCase()];
    for (let index = 0; index < this.gameListForKhm.length; index += 1) {
      const element = this.gameListForKhm[index];
      element.isActive = element.name === item.name;
    }
    this.fetchNewWinlose();
  }

  selectCompany(item) {
    this.Criteria.products = [item.key];
    this.Criteria.gameName = ['total'];
    for (let index = 0; index < this.companyList.length; index += 1) {
      const element = this.companyList[index];
      element.isActive = element.name === item.name;
    }
    this.fetchGame();
    this.fetchNewWinlose();
  }

  async fetchNewWinlose() {
    let res;
    this.Criteria.isSearch = !!this.LoginName;
    const criteria = {
      ...this.Criteria,
      ...this.Period,
      ...this.PaginationDetail,
      time: this.durationTime,
      roundId: this.roundId,
    };
    this.GeneralInstance.toggleLoading(true);
    if (this.roundId) {
      if (!criteria.products.includes('khm_company_total')) {
        criteria.products = criteria.gameName;
      }
      criteria.roundId = this.roundId;
      criteria.role = 'MEMBER';
      res = await this.ReportInstance.FetchRoundId(criteria);
      if (res.code) {
        this.GeneralInstance.toggleLoading(false);
      }
      this.isRangeDate = true;
      this.resultData = { ...res.reportLog };
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...res.breadcrumb];
      this.totalLog = res.reportCount;
      this.summaryLog = res.footerSummary;
      this.PaginationDetail = { ...res.paginationDetail };
      if (res) {
        this.TableHeadLog = [...WinLoseData.TableHeadLog];
        this.TableHeadLog[1] = [...WinLoseData.TableHeadLog[1]];
        const header = this.ReportInstance.dataNewWinLoseLog.reportLog.length
          ? this.ReportInstance.dataNewWinLoseLog.reportLog[0].each
          : [];
        const filterAgent = header.slice(1, header.length - 2);
        const loopTable = WinLoseData.TableHeadLog[1][1];
        const newTable = [];
        filterAgent.forEach(() => newTable.push(loopTable));
        const ownTable = [
          WinLoseData.TableHeadLog[1][0],
          ...newTable.map((v: any, i: number) => ({
            ...v,
            index: newTable.length - i,
          })),
          WinLoseData.TableHeadLog[1][2],
          WinLoseData.TableHeadLog[1][3],
        ];
        this.TableHeadLog[1] = ownTable;
        this.detailFooterCol = header.length;
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
      this.type = 'dataNewWinLoseLog';
      this.dataKey = 'reportLog';
      this.mode = this.isMember
        ? 'member'
        : this.isSubAgent
          ? 'subAgent'
          : 'agent';
      this.mode = 'member';
      this.WinLoseList = { ...this.ReportInstance[this.type] };
      if (res.code) {
        this.checkError(res);
        this.GeneralInstance.toggleLoading(false);
      }
      this.GeneralInstance.toggleLoading(false);
    } else if (this.isMember && !this.durationTime) {
      res = await this.ReportInstance.FetchWinLoseRangeLog(criteria);
      if (res.code) {
        this.checkError(res);
        return false;
      }
      if (typeof res === 'object' && res.users) {
        this.resultData = res;
        this.isRangeDate = false;
        this.GeneralInstance.toggleLoading(false);
        this.TableHeadLog = [...WinLoseData.TableHeadDateRange];
        this.type = this.isMember ? 'dataWinLoseLog' : 'dataWinLose';
        this.mode = this.isMember ? 'member' : 'agent';
        this.WinLoseList = { ...this.ReportInstance[this.type] };
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
    } else if (this.isMember && this.durationTime) {
      if (!criteria.products.includes('khm_company_total')) {
        criteria.products = criteria.gameName;
      }
      criteria.role = 'MEMBER';
      res = await this.ReportInstance.FetchWinloseLogElastic(criteria);
      if (res.code) {
        this.GeneralInstance.toggleLoading(false);
      }
      this.isRangeDate = true;
      this.resultData = { ...res.reportLog };
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...res.breadcrumb];
      this.totalLog = res.reportCount;
      this.summaryLog = res.footerSummary;
      this.PaginationDetail = { ...res.paginationDetail };
      if (res) {
        this.TableHeadLog = [...WinLoseData.TableHeadLog];
        this.TableHeadLog[1] = [...WinLoseData.TableHeadLog[1]];
        const header = this.ReportInstance.dataNewWinLoseLog.reportLog.length
          ? this.ReportInstance.dataNewWinLoseLog.reportLog[0].each
          : [];
        const filterAgent = header.slice(1, header.length - 2);
        const loopTable = WinLoseData.TableHeadLog[1][1];
        const newTable = [];
        filterAgent.forEach(() => newTable.push(loopTable));
        const ownTable = [
          WinLoseData.TableHeadLog[1][0],
          ...newTable.map((v: any, i: number) => ({
            ...v,
            index: newTable.length - i,
          })),
          WinLoseData.TableHeadLog[1][2],
          WinLoseData.TableHeadLog[1][3],
        ];
        this.TableHeadLog[1] = ownTable;
        this.detailFooterCol = header.length;
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
      this.type = this.isMember ? 'dataNewWinLoseLog' : 'dataWinLose';
      this.dataKey = this.isMember ? 'reportLog' : 'report';
      this.mode = this.isMember
        ? 'member'
        : this.isSubAgent
          ? 'subAgent'
          : 'agent';
      this.WinLoseList = { ...this.ReportInstance[this.type] };
      if (res.code) {
        this.checkError(res);
        this.GeneralInstance.toggleLoading(false);
      }
      this.GeneralInstance.toggleLoading(false);
    } else {
      // Trigger new report
      const { data, status } = this.currentAPI === 'v2' ? await this.ReportInstance.FetchNewWinLose(criteria) : await this.ReportInstance.FetchNewWinLoseNightly(criteria);
      if (status) {
        this.checkError(status);
        this.GeneralInstance.toggleLoading(false);
      }
      if (
        ['COMPANY', 'SUPERADMIN', 'SUBCOMPANY'].includes(
          this.Criteria.role && this.AuthInstance.role,
        )
      ) {
        this.FilteredTableHeadMember[0] = [
          ...WinLoseData.TableHeadMember[0],
        ].filter((item: any) => !item.isCompanyHidden);
      } else {
        this.FilteredTableHeadMember = [...WinLoseData.TableHeadMember];
        this.FilteredTableHeadMember[0] = [
          ...WinLoseData.TableHeadMember[0],
        ].filter((item: any) => !item.isAnyHidden);
      }
      if (data.footerSummary && data.footerSummary.length) {
        this.resultData.footerSummary = data.footerSummary;
      } else this.resultData.footerSummary = [];

      this.houseEdge = this.resultData.footerSummary.map((item: any) => ({
        houseEdge: (item.rawWinlose / item.turnover) * -100,
        currency: item.currency,
      })) || 0;
      this.type = 'dataWinLose';
      this.dataKey = 'users';
      this.mode = 'agent';
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...data.breadcrumb];
      this.PaginationDetail.amount = data.pageAmount;
      this.resultData = data;
      if (data.users && data.users.length) {
        this.totalCurrency = data.users
          .filter((item) => item.report.length)
          .map((item) => item.currency);
      } else {
        this.totalCurrency = [];
      }
      this.currencyList = [...this.totalCurrency];
      this.GeneralInstance.toggleLoading(false);
    }
    this.rateCriteria = Object.freeze(criteria);
  }

  async fetchResult(params) {
    const {
      roundId,
      product,
      category,
      prefix,
    } = params;
    const width = (category === 'arcade' && product !== 'PUNPAE')
      || product === 'BINGO'
      || product === 'BINGO2'
      ? 1305
      : 700;
    const height = category === 'arcade' || product === 'BINGO' || product === 'BINGO2'
      ? 630
      : 750;
    const strWindowFeatures = `top=0,left=0,height=${height},width=${width},scrollbars=yes`;
    const param = {
      roundId,
      prefix,
      language: this.$i18n.locale,
    };
    const res = await this.ReportInstance.FetchTransaction(param);
    window.open(res.url, 'gameResult', strWindowFeatures);
  }

  async fetchGame() {
    const partner = {
      partner: 'all',
    };
    const res = await this.GameInstance.FetchGame(partner);
    if (res.code) {
      this.checkError(res);
    } else {
      await this.mapGameInput();
      this.Criteria.gameName = this.GameList.map((item) => item.value);
      this.gameListForKhm = [];
      const listGame = res.games.filter((v) => v.isKhm);
      for (let index = 0; index < listGame.length + 1; index += 1) {
        const element = listGame[index];
        const lastItem = listGame.length === index;
        this.gameListForKhm.push(
          {
            name: lastItem ? 'All' : element.name.en,
            isActive: lastItem,
            prefix: lastItem ? 'total' : element.prefix,
            isKhm: element && element.isKhm,
          },
        );
      }
      this.gameListForKhm.reverse();
    }
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    if (this.$i18n.locale) {
      this.mapGameInput();
    }
  }

  @Watch('isMember')
  onWatchisMember(fact) {
    if (fact) this.Criteria.role = this.AuthInstance.user.role;
  }

  async mapGameInput() {
    const games = await this.GameInstance.game.games
      .filter(
        (g) => g.name.en !== 'jump higher'
          && g.name.en !== 'Angpow'
          && g.status !== 999,
      )
      .map((g) => ({
        name: g.type.charAt(0).toUpperCase() + g.type.slice(1, g.type.length),
        value: g.type,
      }));
    let arr = Array.from(new Set(games.map((a) => a.value)))
      .map((type) => games.find((a) => a.value === type));
    arr = arr.filter((v) => v.value !== 'bonus');
    this.GameList = [...this.DefaultGameList, ...arr];
  }

  handleSearch() {
    this.PaginationDetail.current = 1;
    this.Criteria.username = this.LoginName;
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetchWinloseAgent(username, role, source, id) {
    this.PaginationDetail.current = 1;
    this.PaginationDetail.amount = 1;
    this.durationTime = '';
    this.beforeFetch(username, role, source, id, this.durationTime);
  }

  handleBreadcrumb({
    username, role, source, id,
  }) {
    this.PaginationDetail.current = 1;
    this.PaginationDetail.amount = 1;
    this.durationTime = '';
    this.beforeFetch(
      username,
      role,
      source,
      id,
      this.durationTime,
    );
  }

  beforeFetch(username, role, source, id, durationTime) {
    this.isMember = role === 'MEMBER';
    this.isSubAgent = role === 'AGENT';
    this.LoginName = '';
    this.roundId = '';
    this.Criteria.username = username;
    this.Criteria.source = source;
    this.Criteria.role = role;
    this.Criteria.id = id;
    this.durationTime = durationTime;
    this.fetchNewWinlose();
  }

  handleTimeRange(username, role, source, id, durationTime) {
    this.beforeFetch(username, role, source, id, durationTime);
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchNewWinlose();
  }

  changeDate(Tool) {
    this.durationTime = '';
    this.handleTool(Tool.key);
  }

  onSubmit() {
    this.fetchNewWinlose();
  }

  validateInput() {
    const regex = /^-?\d+(\.\d+)?$/;
    this.isRateValid = !(this.rateValue === '' || regex.test(this.rateValue));
  }

  async downloadReport() {
    const criteria = { criteria: this.rateCriteria, rate: this.rateValue };
    const res = await this.ReportInstance.FetchCSVReport(criteria);
    const text = await res.text();
    try {
      const json = JSON.parse(text);
      if (json.status.code) {
        await this.checkError(json.status);
      }
    } catch {
      saveAs(res, 'report.zip');
    }
  }
}
